import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKatanaComponent } from './simple-icons-katana.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKatanaComponent ],
    exports:      [ SimpleIconsKatanaComponent ],
    bootstrap:    []
})
export class SimpleIconsKatanaModule {}
